import React, { useRef, useState } from 'react';
import workImg from '../assets/work1.jpg'
import Left from '../assets/left.png'
import Right from '../assets/right.png'
import workImg2 from  '../assets/work2.jpg'
import workImg3 from '../assets/work3.jpg'
import workImg4 from '../assets/work4.png'
import workImg5 from '../assets/work5.jpg'



const Card = ({ img, title, info }) => {
    return (
        <a href="/#" className='md:w-2/5 lg:w-1/3  flex-shrink-0 ml-2 md:mr-24 sm:mr-10 min-h-fit'>
        <div className="w-full rounded-xl shadow-lg transition-transform transform hover:scale-105 cursor-pointer border-gray-400 duration-500 ease-in-out">
          <img className="w-full rounded-t-xl h-1/3" src={img} alt={title} />
          <div className="md:px-8 sm:py-4 sm:px-2 md:h-128 lg:h-96 min-h-fit">
            <div className="font-bold py-8 text-base mb-2 text-[#34623F] md:my-4">{title}</div>
            <p className="text-black lg:text-sm sm:text-xs/8 sm:tracking-custom sm:leading-loose my-4 sm:hidden md:block">{info}</p>
          </div>
        </div>
      </a>
    );
  };

function Work() {
    const containerRef = useRef(null);

    const easeInOutQuad = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);

    const handleScroll = (direction) => {
      const container = containerRef.current;

      if (container) {
        const startTime = performance.now();
        const duration = 5; // 滚动动画的持续时间，可以根据需要调整

        const startScroll = container.scrollLeft;
        const scrollDistance = container.clientWidth * 0.3; // 你想要的百分比

        const animateScroll = (currentTime) => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const easedProgress = easeInOutQuad(progress);

          if (direction === 'left') {
            container.scrollLeft = startScroll - scrollDistance * easedProgress;
          } else if (direction === 'right') {
            container.scrollLeft = startScroll + scrollDistance * easedProgress;
          }

          if (progress < 1) {
            requestAnimationFrame(animateScroll);
          }
        };

        requestAnimationFrame(animateScroll);
      }
    };
    const [activeTab, setActiveTab] = useState('论文');

    const handleTabClick = (tab) => {
      setActiveTab(tab);
    };
    // const handleTouchStart = (e) => {
    //   const touchStartX = e.touches[0].clientX;
    //   containerRef.current.dataset.touchStartX = touchStartX;
    // };
    //
    // const handleTouchMove = (e) => {
    //   if (!containerRef.current.dataset.touchStartX) return;
    //
    //   const touchMoveX = e.touches[0].clientX;
    //   const touchStartX = parseFloat(containerRef.current.dataset.touchStartX);
    //   const deltaX = touchStartX - touchMoveX;
    //
    //   containerRef.current.scrollLeft += deltaX;
    //   containerRef.current.dataset.touchStartX = touchMoveX;
    // };
    //
    // const handleTouchEnd = () => {
    //   containerRef.current.dataset.touchStartX = null;
    // };

    const WorkInfo=[
        {
            img: workImg,
            title: '深海羽流重点研发项目',
            info: '“深海羽流影响虚拟仿真可视化平台”是国家级重点研发项目的一个子课题，具体的研究内容是构建一个具备实时监测、动态展示和虚拟仿真等功能的平台，实现监测数据和实验数据的集成展示与沉浸式交互。'
        },
        {
            img: workImg2,
            title: '海洋时空数据超分辨率',
            info: '提出PDNet:全球模式时空数据降尺度方案，利用最新的CMIP6计划中的温度、湿度、风速、位势等多变量，输入我们构建的高效超分网络，得到降水的RCM降尺度结果，预测速度比传统的动力降尺度方案提升百倍，且同时适用于多种变量。'
        },
        {
            img: workImg3,
            title: '海洋三维环境信息可视化大屏',
            info: '基于WebGL的海洋三维环境信息可视化平台,使用轻量级网页3D可视化系统，支持标量场、矢量场、等值线、粒子场、体数据等多种可视化方案。支持NetCDF数据自动入库、实时交互、时间轴播放等海洋数据可视化重点功能。'
        },
        {
          img: workImg4,
            title: '基于物理约束深度学习的八叉树分层采样优化',
            info: '提出了一种基于八叉树的新型分层采样方法。在训练之前对科学数据进行预处理，并构建了一个基于八叉树的层次化数据结构，以指导潜在特征网格上的采样。八叉树中的每个叶子节点对应于体积数据中不可分割的子块。'
        },
        {
          img: workImg5,
            title: '基于自适应滤波和屏幕空间LOD开放海面模拟',
            info: '提出了一种基于屏幕空间策略的大规模开放海面模拟和实时绘制解决方案，针对PM波浪谱模型的样本参数进行多分辨率建模的需求设计了一种基于视角的屏幕空间LOD算法和一种自适应滤波算法，改进了屏幕空间建模算法。'
        }
    ]
    const PaperInfo=[
      'AttGAN: Attention Gated Generative Adversarial Network for Spatio-temporal Super-resolution of Ocean Phenomena， International Journal of Digital Earth， 2024， SCI，中科院一区',
      'Edge-protected IDW-based DEM detail enhancement and 3D terrain visualization， Computers & Graphics， 2024， SCI，CCF-C',
      'Real-Time Wave Simulation of Large-scale Open Sea Based on Self-adaptive Filtering and Screen Space Level of Detail， Journal of Marine Science and Engineering， 2024， SCI，中科院二区',
      'Octree-based hierarchical sampling optimization for the volumetric super-resolution of scientific data， Journal of Computational Physics， 2024， SCI，中科院一区，TOP期刊',
      'MobileSky: Real-time Sky Replacement for Mobile AR， IEEE Transactions on Visualization and Computer Graphics， 2023， CCF-A, 中科院一区, TOP期刊',
      'TransFlowNet: A physics-constrained Transformer framework for spatio-temporal super-resolution of flow simulations， Journal of Computational Science， 2022， SCI，中科院二区',
      'Example-based Large-Scale Marine Scene Authoring Using Wang Cubes  ， Visual Informatics， 2022， ESCI',
      'Real-time Multi-person Multi-camera Tracking Based on Improved Matching Cascade.， The 7th Euro-China Conference on Intelligent Data Analysis and Applications， 2021， 会议',
      'Simulating flying insects using dynamics and data-driven noise modeling to generate diverse collective behaviors， PloS One， 2016， SCI，中科院三区',
      'BSwarm: Biologically-Plausible Dynamics Model of Insect Swarms， SCA ， 2015， 会议，CCF-B',
      'Inherent Noise-Aware Insect Swarm Simulation， Computer Graphics Forum， 2014， SCI，CCF-B',
      'Flock Morphing Animation， Computer Animation and Virtual Worlds， 2014， SCI，CCF-C',
      '基于样本的大规模人群快速创作， 计算机学报， 2014， EI，中文重点期刊'
    ]
    const PatentInfo=[
      '基于物理约束深度学习的八叉树分层采样方法及应用， 审中， 发明专利',
      '边界和初始条件未知的流体数据时空高分辨率重建方法， 审中， 发明专利',
      '一种基于Wang Cubes的大规模海洋场景创作方法及装置， 审中， 发明专利',
      '用于增强现实场景的实时天空替换特效控制方法， 审中， 发明专利',
      '一种面向真实感绘制的海冰数据可视化方法及装置， 2022， 发明专利',
      '三维渲染中输入框的控制方法、装置和电子装置， 2022， 发明专利',
      'AR娃娃机的控制方法、装置和电子装置， 审中， 发明专利',
      '一种能够自动纠偏的AR沙盘校准模型计算方法， 2020， 发明专利',
      '一种基于棋盘格图案的AR沙盘校准模型计算方法， 2020， 发明专利',
      '一种模拟人眼对焦的虚拟动态景深变化处理方法， 2019， 发明专利',
      '一种用于虚拟现实过山车场景的轨道构建和运动计算方法， 2018， 发明专利',
      '一种虚拟骑行健身单车的骑行数据处理方法， 2018， 发明专利',
      '一种飞虫运动模型噪声项的确认方法， 2018， 发明专利',
      '一种基于生物学规则的飞虫群模拟方法， 2018， 发明专利',
      '一种基于噪声感知的飞虫群模拟方法， 2015， 发明专利',
      '一种快速创建大规模虚拟人群的方法， 2014， 发明专利',
      '一种交互编辑虚拟人群场景中虚拟个体的方法， 2014， 发明专利',
      '一种交互编辑虚拟人群场景中虚拟个体的方法， 2014， 发明专利'
    ]
  return (
    <div className='md:w-7/12 sm:w-3/4 mx-auto' id='work'>
        <div className='flex w-full lg:items-center lg:flex-row lg:py-28 justify-between md:py-10 sm:py-4 sm:flex-col'>
              <h2 className='text-[#607744] tracking-widest font-semibold py-4 w-1/3 lg:text-4xl lg:leading-loose md:text-3xl md:w-fit md:leading-loose sm:text-2xl sm:w-fit sm:leading-loose'>
                团队成果展示
                <br className='md:hidden lg:block sm:hidden'>
                </br>
                核心项目成就预览
              </h2>
              <div className='flex flex-col justify-start lg:w-2/5 text-28 lg:leading-loose tracking-widest font-medium sm:w-full sm:leading-loose sm:my-10'>
              <p className='w-full mb-6'>
              见证我们广泛的项目作品集。我们通过先进的三维技术，旨在解决实际问题，为行业带来创新解决方案。
              </p>
              </div>
        </div>
        <div className="md:block sm:hidden">
        <button onClick={() => handleScroll('left')} className="bg-cover bg-center px-4 py-4 rounded-md ml-2 mr-4 transition-transform transform hover:scale-105 duration-500" style={{ backgroundImage: `url(${Left})` }}></button>
        {/* 右滑按钮 */}
        <button onClick={() => handleScroll('right')} className="bg-cover bg-center  px-4 py-4 rounded-md transition-transform transform hover:scale-105 duration-500" style={{ backgroundImage: `url(${Right})` }}></button>
        </div>
        <div className="overflow-hidden relative mb-16 scroll-smooth md:block sm:hidden" ref={containerRef}
         style={{ WebkitOverflowScrolling: 'touch' }}>
            <div  className="flex transition-transform duration-1000 py-8 ease-in-out items-stretch">
                {WorkInfo.map((work, index) => (
                <Card key={index} {...work} />
                ))}
            </div>
        </div>
        <div className="md:hidden sm:block flex flex-col relative overflow-hidden mb-12">
            <div className="flex h-25">
                <div className="relative group overflow-hidden bg-[#34623e] w-1/2">
                    <img src={WorkInfo[0].img} className="group-hover:scale-110 duration-1000 ease-in-out z-10 cursor-pointer opacity-50 group-hover:opacity-100" alt=""/>
                    <p className="absolute bottom-2 left-2 text-white text-center text-sm mx-auto">{WorkInfo[0].title}</p>
                </div>
                <div className="relative group overflow-hidden bg-[#34623e] w-1/2">
                    <img src={WorkInfo[1].img} className="group-hover:scale-110 duration-1000 ease-in-out z-10 cursor-pointer opacity-50 group-hover:opacity-100" alt=""/>
                    <p className="absolute bottom-2 left-2 text-white text-center text-sm mx-auto">{WorkInfo[1].title}</p>
                </div>
            </div>
            <div className="relative group overflow-hidden bg-[#2e7fb8] h-25">
                <img src={WorkInfo[2].img} className="group-hover:scale-110 duration-1000 ease-in-out z-10 cursor-pointer opacity-60 group-hover:opacity-100" alt=""/>
                <p className="absolute bottom-2 left-2 text-white text-center text-xs mx-auto">{WorkInfo[2].title}</p>
            </div>
            <div className="flex h-25">
                <div className="relative group overflow-hidden bg-[#34623e] w-1/2">
                    <img src={WorkInfo[3].img} className="group-hover:scale-110 duration-1000 ease-in-out z-10 cursor-pointer opacity-50 group-hover:opacity-100" alt=""/>
                    <p className="absolute bottom-2 left-2 text-white text-center text-sm mx-auto">{WorkInfo[3].title}</p>
                </div>
                <div className="relative group overflow-hidden bg-[#34623e] w-1/2">
                    <img src={WorkInfo[4].img} className="group-hover:scale-110 duration-1000 ease-in-out z-10 cursor-pointer opacity-50 group-hover:opacity-100" alt=""/>
                    <p className="absolute bottom-2 left-2 text-white text-center text-sm mx-auto">{WorkInfo[4].title}</p>
                </div>
            </div>
        </div>
         <div className='pl-2 mb-28'>
         <span
          onClick={() => handleTabClick('论文')}
          className={`tab-label text-[#34623F] pb-2 cursor-pointer lg:text-2xl md:text-xl mb-10 md:tracking-widest font-semibold inline-block mr-14 transition duration-300 ${
            activeTab === '论文' ? 'border-b-2 border-[#34623F]' : ''
         }`}
        >
          论文
        </span>
        <span
          onClick={() => handleTabClick('专利')}
         className={`tab-label text-[#34623F] pb-2 cursor-pointer lg:text-2xl md:text-xl mb-10 md:tracking-widest font-semibold inline-block transition duration-300 ${
            activeTab === '专利' ? 'border-b-2 border-[#34623F]' : ''
          }`}
        >
        专利
      </span>
      <ul className='pl-4'>
        {activeTab === '论文' &&
          PaperInfo.map((paper, paperIndex) => (
            <li
              key={paperIndex}
              className='tab-content font-semibold list-decimal text-base mb-6 text-[#1E2F23]  break-all leading-loose transition duration-300 opacity-100'
            >
              {paper}
            </li>
          ))}
        {activeTab === '专利' &&
          PatentInfo.map((patent, patentIndex) => (
            <li
              key={patentIndex}
              className='tab-content font-semibold list-decimal text-base mb-6 text-[#1E2F23]  break-all leading-loose transition duration-300 opacity-100'
            >
              {patent}
            </li>
          ))}
      </ul>
        </div>         
    </div>
  )
}

export default Work
